import React from 'react';

const SvgCollection = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M5 3c-1.093 0-2 .907-2 2v6h8V3H5zm8 0v8h8V5c0-1.093-.907-2-2-2h-6zM5 5h4v4H5V5zm10 0h4v4h-4V5zM3 13v6c0 1.093.907 2 2 2h6v-8H3zm10 0v8h6c1.093 0 2-.907 2-2v-6h-8zm-8 2h4v4H5v-4zm10 0h4v4h-4v-4z" />
  </svg>
);

export default SvgCollection;
